import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { label, list } from './styles.module.css';

/**
 * Labels
 */
const Labels = ({ races: { races = [] } }) => {
  const tags = []
    .concat(...races.filter(r => !!r.tags).map(r => r.tags)) // Flatten all tags
    .filter((tag, i, arr) => i === arr.findIndex(t => t.link === tag.link)) // Dedupe
    .filter(tag => !!tag.link) // Not all tags have links (those should not be labels)
    .filter(tag => !tag.link.includes('/calendar/')) // Ignore deprecated calendar links
    .filter(tag => !tag.value.includes('Other')); // Filter out other type
  return (
    <ul className={list}>
      {tags.map(tag => (
        <li key={tag.link}>
          <Link to={tag.link} className={label}>
            {tag.value}
          </Link>
        </li>
      ))}
    </ul>
  );
};

Labels.propTypes = {
  races: PropTypes.shape({
    races: PropTypes.arrayOf(
      PropTypes.shape({
        tags: PropTypes.arrayOf(
          PropTypes.shape({
            link: PropTypes.string,
            value: PropTypes.string.isRequired,
          }),
        ),
      }),
    ).isRequired,
  }),
};

Labels.defaultProps = {
  races: undefined,
};

export default Labels;



// WEBPACK FOOTER //
// ./app/src/components/EventDetail/Labels/index.jsx